const linksGeneral = [
  {
    id: 1,
    title: "Copernicus Services",
    titleCode: "links:copernicus-svc",
    desc: "",
    descCode: "links:d-copernicus-svc",
    url: "https://www.copernicus.eu/en",

  },
  {
    id: 2,
    title: "Copernicus Land Monitoring Service",
    titleCode: "links:copernicus-lms",
    desc: "",
    descCode: "links:d-copernicus-lms",
    url: "https://land.copernicus.eu",
    icon: "book",
    iconColor: "success"
  },
  {
    id: 3,
    title: "Copernicus Land Monitoring Service product portfolio overview",
    titleCode: "links:copernicus-lms-overview",
    desc: "",
    descCode: "links:d-copernicus-lms-overview",
    url: "https://land.copernicus.eu/product-portfolio/overview",
    icon: "language",
    iconColor: "danger"
  },
  {
    id: 4,
    title: "CLC",
    titleCode: "links:clc",
    desc: "",
    descCode: "links:d-clc",
    url: "https://land.copernicus.eu/pan-european/high-resolution-layers",
    icon: "language",
    iconColor: "primary"
  },
  {
    id: 5,
    title: "Technical library",
    titleCode: "links:tech-lib",
    desc: "",
    descCode: "links:d-tech-lib",
    url: "https://land.copernicus.eu/user-corner/technical-library",
    icon: "library_books",
    iconColor: "danger"
  },
  {
    id: 6,
    title: "CLC classes",
    titleCode: "links:clc-classes",
    desc: "",
    descCode: "links:d-clc-classes",
    url: "https://land.copernicus.eu/user-corner/technical-library/corine-land-cover-nomenclature-guidelines/html/",
    icon: "language",
    iconColor: "primary"
  },
  {
    id: 7,
    title: "ENVI Atlas",
    titleCode: "links:envi-atlas",
    desc: "",
    descCode: "links:d-envi-atlas",
    url: "http://envi.azo.hr/?topic=3",
    icon: "language",
    iconColor: "primary"
  },
  {
    id: 8,
    title: "Copernicus Open Access Hub",
    titleCode: "links:copernicus-oah",
    desc: "",
    descCode: "links:d-copernicus-oah",
    url: "https://scihub.copernicus.eu",
    icon: "language",
    iconColor: "primary"
  },
  {
    id: 9,
    title: "Use Cases",
    titleCode: "links:use-cases",
    desc: "",
    descCode: "links:d-use-cases",
    url: "https://land.copernicus.eu/user-corner/land-use-cases",
    icon: "language",
    iconColor: "primary"
  },

];

const linksOrganizations = [
  {
    id: 201,
    title: "MZOIP",
    titleCode: "links:mzoip",
    desc: "",
    descCode: "links:d-mzoip",
    url: "https://www.mzoip.hr",
    icon: "language",
    iconColor: "primary"
  },
  {
    id: 202,
    title: "EEA",
    titleCode: "links:eea",
    desc: "",
    descCode: "links:d-eea",
    url: "https://www.eea.europa.eu",
    icon: "language",
    iconColor: "primary"
  },
  {
    id: 203,
    title: "ESA",
    titleCode: "links:esa",
    desc: "",
    descCode: "links:d-esa",
    url: "https://www.esa.int/Our_Activities/Observing_the_Earth/Copernicus",
    icon: "language",
    iconColor: "primary"
  }

];

export { linksGeneral, linksOrganizations };